import { formatBook } from "../../../utils/formatOdds";
function getExposure(exposures, nat) {
  if (!nat) return 0;
  return (
    exposures[nat] ??
    exposures[nat.toLowerCase()] ??
    exposures[nat.trim()] ??
    0
  );
}

/**
 * BetTableQueen — Queen bet table in the reference markup (allpanel9 admin, tablet/desktop template):
 *   .queen-box > .row > .col-3 × 4 >
 *     .casino-box-row > .casino-nation-name > b(nat)
 *                     + .casino-bl-box[.suspended] > .back.casino-bl-box-item + .lay.casino-bl-box-item
 *                     + .casino-nation-name > span.casino-book.text-danger.book-red|book-green
 * Styled by the ported reference rules (.casino-queen … in index.css).
 * data: the queen markets (nat="Total N", b=back, l=lay, gstatus); suspended unless gstatus is OPEN.
 */
export default function BetTableQueen({ data = [], onBetClick, exposures = {} }) {
  return (
    <div className="queen-box">
      <div className="row">
        {Array.from({ length: 4 }, (_, idx) => {
          const item = data[idx];
          const nat = item?.nat || `Total ${idx}`;
          const back = item?.b ?? 0;
          const lay = item?.l ?? 0;
          const suspended = !item || item?.gstatus !== "OPEN";
          const exposure = getExposure(exposures, nat);

          return (
            <div key={idx} className="col-3">
              <div className="casino-box-row">
                <div className="casino-nation-name">
                  <b>{nat}</b>
                </div>{" "}
                <div className={`casino-bl-box${suspended ? " suspended" : ""}`}>
                  <div
                    data-toggle="modal"
                    data-target="#casino-betslip"
                    className="back casino-bl-box-item"
                    onClick={() => !suspended && onBetClick(back, nat, "back", item)}
                  >
                    <span className="casino-box-odd">{back}</span>
                  </div>{" "}
                  <div
                    className="lay casino-bl-box-item"
                    onClick={() => !suspended && onBetClick(lay, nat, "lay", item)}
                  >
                    <span className="casino-box-odd">{lay}</span>
                  </div>
                </div>{" "}
                <div className="casino-nation-name">
                  <span className={`casino-book text-danger ${exposure > 0 ? "book-green" : "book-red"}`}>{formatBook(exposure)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
